/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesMemberController', ActivitiesMemberController);

    ActivitiesMemberController.$inject = ['$state', 'ActivitiesMember', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams'];

    function ActivitiesMemberController($state, ActivitiesMember, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.setQuery = setQuery;
        vm.query = pagingParams.query;

        loadAll();

        function setQuery(query) {
            vm.query = query;
            vm.transition();
        }

        function loadAll () {
            ActivitiesMember.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                select: $stateParams.query
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.activities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                query: vm.query
            });
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'activitiesDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
